/**
 * Filters and sorts a list of recipes based on a search query.
 *
 * @param {Array} recipeList - The list of recipes to filter and sort.
 * @param {string} searchQuery - The search term used to filter recipes.
 * @returns {Array} - The filtered and sorted list of recipes.
 */
export const filterAndSortRecipes = (recipeList, searchQuery) => {
  let filtered = recipeList;
  if (searchQuery) {
    filtered = recipeList.filter((recipe) => recipe.title.toLowerCase().includes(searchQuery.toLowerCase()));
  }
  return [...filtered].sort((a, b) => a.title.localeCompare(b.title));
};
